<input
    name="stringValue"
    [ngModel]="$editString()"
    (ngModelChange)="setEditString($event)"
    [ngModelOptions]="{standalone: true}"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [class.cm-invalid]="!$editValid()"
    class="cm-input"
    [disabled]="$disabled()"
    [readonly]="$readonly()"
    [class.cm-button]="$isButton()"
/>
